/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var _ = require('underscore');
var toggleForm = require('common/util/toggleForm');

var AddressView = require('common/views/AddressView');

var tmplConSerComplaintFormForPrintingView = require('../templates/ConSerComplaintFormForPrintingView.hbs');
require('../styles/ConSerComplaintFormForPrintingView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerComplaintFormForPrintingView,

  className: 'con-ser-complaint-form-for-printing-view row',

  ui: {
    addressFormContainer: '.address-form-container',
    isNotConsumerForm: '.is-not-consumer-form',
    hasContactedAttemptForm: '.has-contacted-attempt-form',
    checkboxes: '.issue-checkbox',
    otherIssueBox: 'input[type="checkbox"][name="32"]',
    otherIssueForm: '.other-issue-form'
  },

  regions: {
    address: '@ui.addressFormContainer'
  },

  events: {},

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  templateHelpers: {
    isReadOnly: true
  },

  onAttach: function() {
    this.switchToPrint();
  },

  onBeforeShow: function() {
    var complaint = this.model.get('complaint') || {};
    if (complaint.isComplainant === '0') {
      toggleForm(this.ui.isNotConsumerForm, true);
    }
    if (complaint.hasAttemptedContact === '1') {
      toggleForm(this.ui.hasContactedAttemptForm, true);
    }

    this.address = new AddressView({
      model: new Backbone.Model(complaint),
      horizontal: true,
      isRequired: false,

      startingCountry: complaint.country,
      startingPostalCode: complaint.postalCode,
      startingCounty: complaint.county
    });

    this.showChildView('address', this.address);

    Syphon.deserialize(this, complaint);

    var checks = complaint.issues;
    if (checks) {
      _.forEach(this.ui.checkboxes, function(checkbox) {
        checkbox.checked =
          _.some(checks, function(issue) {
            return issue.ComplaintIssueID === checkbox.value;
          }) || checks.ComplaintIssueID === checkbox.value;
      });
    }

    toggleForm(this.ui.otherIssueForm, this.ui.otherIssueBox[0].checked);
  },

  switchToPrint: function() {
    var textAreas = $('.input-view');

    _.each(textAreas, function(textArea) {
      var textAreaVal = textArea.value;
      var textAreaName = textArea.name;
      var printElementId = '#'.concat(textAreaName, 'PrintView');
      $(printElementId).text(textAreaVal);
    });
    toggleForm(textAreas, false);
  }
});
